import { motion } from "framer-motion";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import "../style/FaqStyle.css";

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    const faqs = [
        {
            question: "Do I need to install any software?",
            answer: "No. DayDone runs entirely in your web browser, so there's nothing to install. You can access it from your phone, tablet, or computer."
        },
        {
            question: "Can I try DayDone before paying?",
            answer: "Yes. You can start a free trial to explore all features before committing to a paid plan."
        },
        {
            question: "Does DayDone work on mobile devices?",
            answer: "Absolutely. DayDone is designed for use on-site and on the go, working seamlessly on phones and tablets."
        },
        {
            question: "Is DayDone suitable for UK businesses?",
            answer: "Yes. DayDone is built specifically for UK mobile service businesses and contractors, with VAT handling, GBP pricing, and British date formats."
        },
        {
            question: "Does DayDone integrate with accounting software?",
            answer: "DayDone integrates with QuickBooks UK & Xero, making it easy to keep your invoicing and accounts in sync. You can also pick which jobs you want linking to accountancy or not if required."
        },
        {
            question: "How do I collect payments from customers?",
            answer: "We offer several payment options. You can accept secure online payments through Stripe, allowing customers to pay quickly and safely. Bank transfers can be made directly to your bank account, and cash payments are also supported."
        },
        {
            question: "Is my data secure?",
            answer: "Yes. Your data is protected with enterprise-grade security, including encryption in transit and at rest, regular security updates, and daily automated backups."
        },
        {
            question: "Is my data backed up?",
            answer: "Yes. All data is automatically backed up daily to ensure nothing is lost."
        },
        {
            question: "What kind of support do you offer?",
            answer: "We provide email support from people who understand UK mobile service businesses and contracting. Feature requests are welcome and often implemented at no extra cost."
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="container">
                <motion.div
                    className="text-center mb-5"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.15
                            }
                        }
                    }}
                >
                    <motion.h2
                        className="faq-title"
                        variants={fadeInUp}
                    >
                        FAQ
                    </motion.h2>
                    <motion.p
                        className="faq-subtitle"
                        variants={fadeInUp}
                    >
                        Everything you need to know about DayDone
                    </motion.p>
                </motion.div>

                <motion.div
                    className="faq-container"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.1
                            }
                        }
                    }}
                >
                    {faqs.map((faq, index) => (
                        <motion.div
                            key={index}
                            className="faq-item"
                            variants={fadeInUp}
                        >
                            <button
                                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <span>{faq.question}</span>
                                <ChevronDown 
                                    className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}
                                    size={24}
                                />
                            </button>
                            <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                                <p>{faq.answer}</p>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default FAQSection;